var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.388184H7.2C2.604 0.388184 0 2.99219 0 7.58818V20.1882C0 24.7842 2.604 27.3882 7.2 27.3882H19.8121C24.408 27.3882 27 24.7842 27 20.1882V7.58818C27 2.99219 24.408 0.388184 19.8121 0.388184Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4749 11.8462C10.1909 11.8462 9.96093 11.6092 10.0049 11.3292C10.2799 9.62818 11.5759 8.38818 13.8249 8.38818C16.0749 8.38818 17.5919 9.74818 17.5919 11.6032C17.5919 12.9472 16.9269 13.8912 15.8019 14.5762C14.7019 15.2352 14.3879 15.6942 14.3879 16.5862V16.6162C14.3879 16.7488 14.3353 16.876 14.2415 16.9697C14.1477 17.0635 14.0205 17.1162 13.8879 17.1162H13.1179C12.9862 17.1162 12.8598 17.0642 12.7661 16.9715C12.6725 16.8788 12.6192 16.7529 12.6179 16.6212L12.6149 16.4212C12.5719 15.2002 13.0919 14.4202 14.2599 13.7092C15.2899 13.0772 15.6569 12.5742 15.6569 11.6812C15.6569 10.7022 14.8989 9.98318 13.7309 9.98318C12.7219 9.98318 12.0209 10.5122 11.7929 11.3852C11.7269 11.6392 11.5149 11.8462 11.2529 11.8462H10.4759H10.4749ZM13.4959 20.3882C14.1179 20.3882 14.5909 19.9142 14.5909 19.2982C14.5909 18.6802 14.1179 18.2062 13.4959 18.2062C12.8899 18.2062 12.4089 18.6802 12.4089 19.2972C12.4089 19.9142 12.8899 20.3882 13.4959 20.3882Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.bebc55221d3a2e46ab0b1cf60752019b.svg";
export { ForwardRef as ReactComponent };